<template>
  <v-app>
    <NotificationBar />

    <main-header
      :lock-buttons="initialState !== 'done'"
      :height="headerHeight"
      :mobile-view="mobileBreakpoint"
    />

    <v-main
      class="main"
      :style="{ 'background-color': appColor.mainLight }"
    >
      <div
        v-if="initialState === 'done'"
        class="fill-height justify-center"
        data-test="loading-done"
      >
        <router-view :key="$route.fullPath" />
      </div>

      <v-container
        v-else
        class="fill-height justify-center"
      >
        <div
          v-if="initialState === 'loading'"
          class="main__loading"
        >
          <SvsLoading />
          <span class="mt-2">Загрузка...</span>
        </div>

        <div
          v-else-if="initialState === 'error' || initialState === 'noLicense'"
          data-test="error-page"
        >
          <p
            :style="{ 'color': appColor.textDark }"
            class="main__error-text"
          >
            <span v-if="initialState === 'noLicense'">Лицензия отсутствует<br>Обратитесь к администратору</span>
            <span v-else>Не удалось загрузить данные</span>
          </p>
          <v-btn
            v-if="initialState === 'error'"
            class="main__btn mt-10"
            :color="`${appColor.secondary} !important`"
            :disabled="btnDisabled"
            data-test="try-again-btn"
            @click="btnClicked"
          >
            <v-icon
              left
              size="22"
              class="mr-3"
            >
              bi-arrow-clockwise
            </v-icon>
            Попробовать еще раз
          </v-btn>
        </div>
      </v-container>
    </v-main>

    <main-footer :height="footerHeight" />
  </v-app>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import MainHeader from '@/components/MainHeader'
import MainFooter from '@/components/MainFooter'
import { apiPolicies, apiResetAllDocuments } from '@/api/api'
import NotificationBar from '@/components/NotificationBar'
import { isArray } from '@/helpers/helpers'
import SvsLoading from '@/components/svg/SvsLoading.vue'

export default {
  name: 'App',
  components: {
    SvsLoading,
    NotificationBar,
    MainHeader,
    MainFooter
  },

  data () {
    return {
      initialState: 'idle',
      notification: {
        show: false,
        isError: false
      },
      btnDisabled: false,
      appColor: this.$appConfig.color,
      footerHeight: 50
    }
  },

  computed: {
    ...mapGetters({ policiesIsLoaded: 'policiesIsLoaded' }),

    headerHeight () {
      return !this.mobileBreakpoint ? 75 : 110
    },
    mobileBreakpoint () {
      return this.$vuetify.breakpoint.mobile
    }
  },

  async created () {
    await this.initialLoading()
  },

  methods: {
    ...mapActions(['saveInitialState', 'savePolicies', 'saveInitialState']),

    btnClicked () {
      if (this.btnDisabled) {
        return
      }
      this.btnDisabled = true
      this.initialLoading()
      setTimeout(() => {
        this.btnDisabled = false
      }, 3000)
    },

    async initialLoading () {
      this.saveInitialState()

      this.initialState = 'loading'
      const policies = await apiPolicies()

      if (!policies) {
        this.initialState = 'error'
        return
      }

      if (Object.hasOwn(policies, 'IsLicenseValid') && !policies.IsLicenseValid) {
        this.initialState = 'noLicense'
        return
      }

      if (isArray(policies.SignatureDescriptions)) {
        this.savePolicies(policies)
        const reset = await apiResetAllDocuments()
        this.initialState = reset ? 'done' : 'error'
      } else {
        this.initialState = 'error'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .main {
    background-color: $color-main-light;

    &__btn {
      display: block;
      width: 300px;
      height: 50px !important;
      margin: 0 auto;

      @include cp-button;
    }

    &__loading {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
    }

    &__error-text {
      text-align: center;
      font-size: 24px;
    }
  }
</style>

<style lang="scss">
  @import '@/styles/index.scss';
</style>

<style src="vue-resize/dist/vue-resize.css" />
